module.exports = __webpack_public_path__ + "img/duck.1c146bd.png";